import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import { reducer as formReducer } from 'redux-form';
import {reducer as burgerMenu} from 'redux-burger-menu';

import core from './core/reducers/core';
import auth from './auth/reducers/auth';
import booking from './booking/reducers/booking';
import survey from './survey/reducers/survey';
import jobs from './jobs/reducers/jobs';
import terminals from './terminals/reducers/terminals';
import profile from './profile/reducers/profile';
import address from './address/reducers/address';
import admin from './admin/reducers/admin';

const rootReducer = combineReducers({
	core: core,
	routing: routerReducer,
	form: formReducer,
	auth: auth,
	booking: booking,
	survey: survey,
	jobs: jobs,
	terminals: terminals,
	profile: profile,
	address: address,
	admin: admin,
	burgerMenu: burgerMenu
});

export default rootReducer;


// WEBPACK FOOTER //
// ./app/rootReducer.js